import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'filter',
	standalone: true,
})
export class FilterPipe implements PipeTransform {
	transform<T extends object>(items: T[], key: string, valuesToFilter: string[]): T[] {
		return items.filter(item => key in item && valuesToFilter.includes(item[key]));
	}
}
